/* eslint-disable warp-drive/no-legacy-request-patterns */
import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ENV from '../config/environment';

export default class SchoolSchemaService extends Service {
  @service
  fetch;

  @service
  store;

  @tracked
  schemaFetched = false;

  getPeopleSchema() {
    let store = this.store;
    let promise = Promise.resolve();
    if (!this.schemaFetched) {
      promise = this.fetch
        .request(
          ENV.APP.apiHost +
            '/v4/people/schema/schools/d2729515-d1ca-436c-8e0a-11870867f7d9/groups',
        )
        .then((response) => {
          this.store.pushPayload({ 'people-groups': response.groups });
          this.schemaFetched = true;
        });
    }
    return promise.then(() => {
      return store
        .peekAll('people-group')
        .filter((g) => g.schoolId === 'd2729515-d1ca-436c-8e0a-11870867f7d9');
    });
  }
}
